module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', [_c('basic-toolbar', {
    attrs: {
      "title": 'Bolsas Cadastradas na Universidade'
    }
  }), _vm._v(" "), _c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "filter_list",
      "label": "Filtrar resultados"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaBolsas,
      "search": _vm.search,
      "no-data-text": 'Nenhuma bolsa encontrada',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', {
          staticClass: "text-xs-center",
          attrs: {
            "width": "10%"
          }
        }, [_vm._v(_vm._s(props.item.codigo))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center",
          attrs: {
            "width": "40%"
          }
        }, [_vm._v(_vm._s(props.item.descricao))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center",
          attrs: {
            "width": "30%"
          }
        }, [_vm._v(_vm._s(props.item.unidade ? props.item.unidade.nome : '-'))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center",
          attrs: {
            "width": "10%"
          }
        }, [_vm._v(_vm._s(props.item.valor))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center",
          attrs: {
            "width": "10%"
          }
        }, [_vm._v(_vm._s(props.item.vagasOcupadas + '/' + props.item.vagasOferecidas))])])]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n            Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaBolsas.length) + " bolsas\n          ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.toCriarBolsa
    }
  }, [_vm._v("Criar bolsa")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-388cd710","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/bolsas/lista-bolsas.vue
// module id = 371
// module chunks = 0